// Formats a decimal fraction as a percentage (0.0384 -> "3.84%").
export const formatPercent = (
    value: number | null | undefined,
    minimumFractionDigits: number,
    maximumFractionDigits = minimumFractionDigits
): string =>
    value == null ? '' : value.toLocaleString('en-US', { style: 'percent', minimumFractionDigits, maximumFractionDigits });
